import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { CommonButton } from '../CommonComponents';
import './DealerSignStamp.css';

const DealerSignStamp = ({
  handleBack,
  isShowEntireApp,
  previewData,
  userId,
  printNow,
  isPrinting,
}) => {
  const navigate = useNavigate();

  return (
    <div className='business-information' id='dealerSign'>
      <Row>
        {isPrinting && (
          <Col xs={12}>
            <hr className='divider' />
          </Col>
        )}
        {isPrinting && (
          <Col xs={12}>
            <div className='name-sign-block'>
              <div>
                <div className='signItext'>Dealer Sign and Stamp</div>
                <div className='signItext pt-4'>Date:</div>
              </div>
              <div>
                <div className='signItext'>TM/SE Name</div>
                <div className='signItext'>TM/SE Sign.</div>
              </div>
            </div>
          </Col>
        )}
        <Col xs={12} className='noprint'>
          <div className='text-center buttonBlock'>
            <CommonButton name={'Back'} btnClass={'btnTernary'} type="button" onClick={handleBack} />
            {previewData.is_verified === false ||
              previewData.is_verified === null ? (
              <CommonButton
                name={'Verification'}
                btnClass={'btnPrimary'}
                disabled={!(userId && (previewData.page_1 === 1 &&
                  previewData.page_2 === 1 &&
                  previewData.page_3 === 1 &&
                  previewData.page_4 === 1 &&
                  previewData.page_5 === 1 &&
                  previewData.page_6 === 1 &&
                  previewData.page_7 === 1 &&
                  previewData.page_8 === 1))}
                // maxWidth='180px'
                type="button"
                onClick={() =>
                  userId &&
                    previewData.page_1 === 1 &&
                    previewData.page_2 === 1 &&
                    previewData.page_3 === 1 &&
                    previewData.page_4 === 1 &&
                    previewData.page_5 === 1 &&
                    previewData.page_6 === 1 &&
                    previewData.page_7 === 1 &&
                    previewData.page_8 === 1
                    ? navigate(`/pages/verify-n-submit/${userId}`)
                    : undefined
                }
              />
            ) : (
              ''
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(DealerSignStamp);
